import '@stylus/main.styl'

import Vue from 'vue'
import { App } from '@/app'
import router from '@/router'
import Devinho from '@lib/devinho'

Vue.config.productionTip = false

Vue.use(Devinho)

Vue.prototype.$eventBus = new Vue();

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
